<template>
  <section class="pt-5">
    <b-container fluid class="pb-4 px-lg-4">
      <b-row>
        <b-col>
          <section
            class="success-payment d-flex justify-content-center align-items-center flex-column"
            v-if="paymentSuccess"
          >
            <h3 class="h3 font-bold mb-2 text-center">
              ¡Felicidades!
            </h3>
            <p>Es momento de llevar tu negocio al siguiente nivel.</p>
            <button
              type="button"
              class="btn md__btn-primary px-5 my-4 center"
              name=""
              @click.prevent="goPage('dashboard')"
            >
              Gestionar Negocio
            </button>
          </section>

          <section
            class="success-payment d-flex justify-content-center align-items-center flex-column"
            v-if="paymentError"
          >
            <h3 class="h3 font-bold mb-2 text-center">
              Ups!
            </h3>
            <p class="text-center" v-if="errorMsg">{{ errorMsg }}</p>
            <p class="text-center" v-else>
              No se ha podido completar la validación del pago, <br />por favor
              intente nuevamente o escriba a
              <span class="font-bold text-color-secondary"
                >soporte@mydessk.com</span
              >
            </p>
            <router-link
              :to="{ name: 'plans' }"
              class="btn md__btn-primary px-5 my-4"
            >
              Volver a planes
            </router-link>
          </section>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import payService from "../services/payService";

export default {
  name: "PlansCheckouts",
  data() {
    return {
      clientTransactionId: null,
      id: null,
      cardToken: null,
      paymentSuccess: false,
      paymentError: false,
      errorMsg: null
    };
  },
  methods: {
    goPage(name) {
      this.$router.push({ name });
    },
    async checkoutPpSubscription() {
      this.$store.dispatch("toggleRequestLoading", {
        text: "Por favor espere un momento, estamos validando la transacción."
      });
      const data = {
        client: this.clientTransactionId,
        transaction: this.id,
        cardToken: this.cardToken
      };
      // El clientTransactionId lleva un prefijo por tipo de transacción (ver
      // SubscriptionController::payPpSubscription, WhatsappAddonController::
      // activatePp/topupPp y AiCreditController::payPp en seshub-backend) —
      // con eso rebotamos al confirm correcto sin tocar el flujo del plan.
      const clientId =
        typeof this.clientTransactionId === "string"
          ? this.clientTransactionId
          : "";
      const isWhatsappAddonActivation = clientId.startsWith("waaddon-");
      const isWhatsappWalletTopup = clientId.startsWith("watopup-");
      const isAiCreditPack = clientId.startsWith("aipack-");
      const isPlanCheckout =
        !isWhatsappAddonActivation && !isWhatsappWalletTopup && !isAiCreditPack;

      const confirmCall = isWhatsappAddonActivation
        ? payService.checkoutActivateWhatsappAddonPp(data)
        : isWhatsappWalletTopup
        ? payService.checkoutTopupWhatsappWalletPp(data)
        : isAiCreditPack
        ? payService.checkoutAiCreditPackPp(data)
        : payService.checkoutPpSubscription(data);

      try {
        let response = await confirmCall.finally(() => {
          this.$store.dispatch("toggleRequestLoading");
        });
        const { success, message } = response.data;

        if (success) {
          this.paymentSuccess = true;
          if (isPlanCheckout) {
            this.$store.dispatch("fetchUserPlan");
            this.$store.commit("RESET_PLANS_LOADED");
          }
          this.$notifications.success({
            message: message || "Compra confirmada correctamente"
          });
        } else {
          this.paymentError = true;
        }
      } catch (error) {
        this.paymentError = true;
        return false;
      }
    }
  },
  computed: {},
  props: {},
  mounted() {
    const { id, clientTransactionId, ctoken, msg } = this.$route.query;

    if (msg && !id) {
      this.errorMsg = decodeURIComponent(msg);
      this.paymentError = true;
      return;
    }

    if (id && clientTransactionId) {
      this.id = id;
      this.clientTransactionId = clientTransactionId;
      this.cardToken = ctoken || null;

      this.checkoutPpSubscription();
    }
  }
};
</script>

<style lang="scss" scoped></style>
